module.exports = __webpack_public_path__ + "static/media/NoProfileImage@3x.c1a97af1.png";